// @ts-nocheck
import * as Types from '../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type UseRoomTypeFilterQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type UseRoomTypeFilterQuery = { __typename?: 'Query', roomTypes: Array<{ __typename?: 'RoomType', id: string, name: string }> };


export const UseRoomTypeFilterDocument = gql`
    query UseRoomTypeFilter {
  roomTypes {
    id
    name
  }
}
    `;

/**
 * __useUseRoomTypeFilterQuery__
 *
 * To run a query within a React component, call `useUseRoomTypeFilterQuery` and pass it any options that fit your needs.
 * When your component renders, `useUseRoomTypeFilterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUseRoomTypeFilterQuery({
 *   variables: {
 *   },
 * });
 */
export function useUseRoomTypeFilterQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<UseRoomTypeFilterQuery, UseRoomTypeFilterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UseRoomTypeFilterQuery, UseRoomTypeFilterQueryVariables>(UseRoomTypeFilterDocument, options);
      }
export function useUseRoomTypeFilterLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UseRoomTypeFilterQuery, UseRoomTypeFilterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UseRoomTypeFilterQuery, UseRoomTypeFilterQueryVariables>(UseRoomTypeFilterDocument, options);
        }
// @ts-ignore
export function useUseRoomTypeFilterSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<UseRoomTypeFilterQuery, UseRoomTypeFilterQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<UseRoomTypeFilterQuery, UseRoomTypeFilterQueryVariables>;
export function useUseRoomTypeFilterSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UseRoomTypeFilterQuery, UseRoomTypeFilterQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<UseRoomTypeFilterQuery | undefined, UseRoomTypeFilterQueryVariables>;
export function useUseRoomTypeFilterSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UseRoomTypeFilterQuery, UseRoomTypeFilterQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<UseRoomTypeFilterQuery, UseRoomTypeFilterQueryVariables>(UseRoomTypeFilterDocument, options);
        }
export type UseRoomTypeFilterQueryHookResult = ReturnType<typeof useUseRoomTypeFilterQuery>;
export type UseRoomTypeFilterLazyQueryHookResult = ReturnType<typeof useUseRoomTypeFilterLazyQuery>;
export type UseRoomTypeFilterSuspenseQueryHookResult = ReturnType<typeof useUseRoomTypeFilterSuspenseQuery>;
export type UseRoomTypeFilterQueryResult = ApolloReactCommon.QueryResult<UseRoomTypeFilterQuery, UseRoomTypeFilterQueryVariables>;